//src/utils/share.js
export const sendWhatsAppMessage = (questionCode, url) => {
    const message = `Take the assessment using this code: ${questionCode}.\nVisit: ${url}`;
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
};

export const sendEmail = (questionCode, url) => {
    const subject = `Take the Assessment`;
    const body = `Use this question code: ${questionCode}.\nAccess here: ${url}`;
    const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
};